import { createSlice } from "@reduxjs/toolkit";
import {
  FETCH_PROJECT_START,
  FETCH_PROJECT_SUCCESS,
  FETCH_PROJECT_FAILURE,
} from "state/types/actionTypes";

const initialState = {
  project: {},
  loading: false,
  error: null,
};

const projectSlice = createSlice({
  name: "project",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(FETCH_PROJECT_START, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(FETCH_PROJECT_SUCCESS, (state, action) => {
        state.project = action.payload;
        state.loading = false;
      })
      .addCase(FETCH_PROJECT_FAILURE, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const projectReducer = projectSlice.reducer;
